// extracted by mini-css-extract-plugin
export default {"background":"BackedBy_background__K+ir0","backedBy":"BackedBy_backedBy__ksva0","logos":"BackedBy_logos__+BKY8","link":"BackedBy_link__gY3E0"};